import {
  GUI_TIN_NHAN,
  GUI_TIN_NHAN_SUCCESS,
  GUI_TIN_NHAN_FAILURE,
  SHOW_GUI_TIN_NHAN,
} from "./actionTypes";

export const guiTinNhan = (dataPost, callback) => ({
  type: GUI_TIN_NHAN,
  dataPost,
  callback,
});

export const guiTinNhanSuccess = (data) => ({
  type: GUI_TIN_NHAN_SUCCESS,
  payload: data,
});

export const guiTinNhanFailure = () => ({
  type: GUI_TIN_NHAN_FAILURE,
});

export const showModalGuiTinNhan = (dataPost) => ({
  type: SHOW_GUI_TIN_NHAN,
  dataPost,
});
